import { useEffect, useRef } from 'react';
import { InputState } from './facet-navigations.utils';
export const useInputStateChange = (inputValue) => {
    const previousInputValue = usePreviousInputValue(inputValue);
    if (previousInputValue.length > 0 && !inputValue.length) {
        return InputState.Cleared;
    }
    if (!previousInputValue.length && inputValue.length > 0) {
        return InputState.Populated;
    }
    return null;
};
const usePreviousInputValue = (value) => {
    const previous = useRef('');
    useEffect(() => {
        previous.current = value;
    }, [value]);
    return previous.current;
};
